import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from "../../../imports/muiImport";
import { useEffect, useState, useSelector, useDispatch } from "../../../imports/generalImport";

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import { handleAmount } from '../../../shared/extra';
import { fetchUserBalance } from "../../../store/userBalance/action";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Bell, Heart, Menu, Search } from "lucide-react";

function MobileNavbar({ toggleDrawer, isPageTitleUpdate, pageTitle }) {
    const [canGoBack, setCanGoBack] = useState(false);
    const UserInfomation = useSelector((state) => state.UserProfile?.allData);
    const balance = useSelector((state) => state.UserBalance.allData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(fetchUserBalance());
        }
    }, [isLoggedIn]);

    useEffect(() => {
        // Check if the user has browser history
        if (window.history.length > 1) {
            setCanGoBack(true);
        }
    }, []);


    const handleBackClick = () => {
        if (canGoBack) {
            navigate(-1); // Navigate back if there's history
        } else {
            navigate('/'); // Redirect to home if there's no history
        }
    };


    function capitalize(word) {
        return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
    }




    return (
        <AppBar
            position="fixed"
            sx={{
                width: '100%',
                boxShadow: 0,
                borderRadius: 0,
                backgroundColor: 'white.main',
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    px: 2,
                    py: 1,
                    minHeight: "56px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {/* Left Icon: Back or Menu */}
                <Box>
                    {isPageTitleUpdate ? (
                        <IconButton
                            size="medium"
                            edge="start"
                            aria-label="back"
                            onClick={handleBackClick}
                            sx={{
                                color: "primaryDark.main",
                                p: 1.2,
                            }}
                        >
                            <ArrowBackIosIcon sx={{ fontSize: 22 }} />
                        </IconButton>
                    ) : (
                        <IconButton
                            size="medium"
                            edge="start"
                            aria-label="menu"
                            onClick={toggleDrawer(true)}
                            sx={{
                                color: "primaryDark.main",
                                p: 1.2,
                                mr: 1,
                            }}
                        >
                            <Menu
                                style={{
                                    fontSize: 26,
                                    stroke: "#002865",
                                    strokeWidth: 1.5,
                                }}
                            />
                        </IconButton>
                    )}
                </Box>

                {/* Center Title/User Info */}
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                    {isPageTitleUpdate ? (
                        <Typography
                            variant="h6"
                            sx={{
                                color: "primaryDark.main",
                                fontWeight: 600,
                                fontSize: "1rem",
                                textTransform: "capitalize",
                                textAlign: "left",
                            }}
                        >
                            {capitalize(pageTitle)}
                        </Typography>
                    ) : isLoggedIn ? (
                        UserInfomation?.data ? (
                            <Stack spacing={0.2}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "primaryDark.main",
                                        fontWeight: 500,
                                        fontSize: "0.975rem",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {UserInfomation.data.name}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "dark.main",
                                        fontSize: "0.75rem",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    Wallet: ₹{balance > 1 ? handleAmount(balance) : "0.00"}
                                </Typography>
                            </Stack>
                        ) : (
                            <CircularProgress sx={{ color: "primary.main" }} size={16} thickness={4} />
                        )
                    ) : (
                        <Typography
                            variant="h6"
                            sx={{
                                color: "primaryDark.main",
                                fontWeight: 500,
                                fontSize: "1rem",
                                textTransform: "capitalize",
                            }}
                        >
                            Guest
                        </Typography>
                    )}
                </Box>

                {(isLoggedIn && !isPageTitleUpdate) && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        {!['/', '/search']?.includes(location?.pathname) && (<IconButton
                            size="medium"
                            sx={{ p: 1 }}
                            aria-label="search"
                        >
                            <NavLink to="/search">
                                <Search
                                    style={{
                                        fontSize: 26,
                                        stroke: "#002865",
                                        strokeWidth: 1.5,
                                    }}
                                />
                            </NavLink>
                        </IconButton>)}

                        <IconButton
                            size="medium"
                            sx={{ p: 1 }}
                            aria-label="notifications"
                        >
                            <NavLink to="/profile/notifications">
                                <Bell
                                    style={{
                                        fontSize: 26,
                                        stroke: "#002865",
                                        strokeWidth: 1.5,
                                    }}
                                />
                            </NavLink>
                        </IconButton>
                    </Box>
                )}
            </Toolbar>

        </AppBar>
    )

    return (
        <AppBar
            position="sticky"
            sx={{
                top: 0,
                // px: 1,
                boxShadow: 0,
                backgroundColor: "white.main",
                maxWidth: 444,
                display: 'flex',
            }}
        >
            <Toolbar sx={{ outline: '2px solid blue' }}>
                {isPageTitleUpdate ?
                    (
                        <IconButton
                            size="large"
                            edge="start"
                            aria-label="menu"
                            sx={{ color: "primaryDark.main" }}
                            onClick={handleBackClick}
                        >
                            <ArrowBackIosIcon sx={{ fontSize: 22 }} />
                        </IconButton>
                    )
                    :
                    (
                        <IconButton
                            size="large"
                            edge="start"
                            aria-label="menu"
                            sx={{
                                color: "primaryDark.main",
                                borderRadius: "50%",
                                border: 1.5,
                                borderColor: "primary.main",
                                p: 0,
                                mr: 1,

                            }}
                            onClick={toggleDrawer(true)}
                        >
                            <Menu
                                style={{
                                    fontSize: 26,
                                    stroke: '#002865',
                                    strokeWidth: 1.5,
                                }}
                            />
                        </IconButton>
                    )
                }



                {isPageTitleUpdate ?
                    <Stack sx={{ flexGrow: 1 }}>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{
                                flexGrow: 1,
                                color: "primaryDark.main",
                                textTransform: "capitalize"
                            }}
                        >
                            {capitalize(pageTitle)}
                        </Typography>
                    </Stack>
                    :
                    (
                        isLoggedIn ? (
                            UserInfomation && UserInfomation.data ? (
                                <Stack sx={{ flex: 1 }}>
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        sx={{
                                            color: "primaryDark.main",
                                            textTransform: "capitalize",
                                            flexGrow: 1,
                                        }}
                                    >
                                        {UserInfomation.data.name}
                                    </Typography>

                                    <Typography
                                        variant="inherit"
                                        component="div"
                                        sx={{
                                            flexGrow: 1,
                                            color: "dark.main",
                                            fontSize: "0.725rem"
                                        }}
                                    >
                                        Wallet Balance: ₹{balance > 1 ? handleAmount(balance) : "0.00"}
                                    </Typography>
                                </Stack>
                            ) : (
                                <Stack sx={{ flexGrow: 1 }}>
                                    <CircularProgress sx={{ color: "primary.main" }} size={15} />
                                </Stack>
                            )
                        ) : (
                            <Stack sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: "primaryDark.main" }}>
                                    Guest
                                </Typography>
                            </Stack>
                        )
                    )
                }

                {(isLoggedIn && !isPageTitleUpdate) && (
                    <Box
                        component={"div"}
                        sx={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "flex-end",
                            columnGap: 1,
                        }}
                    >
                        {/* <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                sx={{
                                    p: 0
                                }}
                            >
                                <NavLink to={'/profile/notifications'} >
                                    <Heart
                                        style={{
                                            fontSize: 26,
                                            stroke: '#002865',
                                            strokeWidth: 1.5,
                                        }}
                                    />
                                </NavLink>
                            </IconButton> */}

                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            sx={{
                                p: 0
                            }}
                        >
                            <NavLink to={'/profile/notifications'} >
                                <Bell
                                    style={{
                                        fontSize: 26,
                                        stroke: '#002865',
                                        strokeWidth: 1.5,
                                    }}
                                />
                            </NavLink>
                        </IconButton>
                    </Box>
                )}

            </Toolbar>
        </AppBar>
    );
}

export default MobileNavbar